export const environment = {
  production: false,
  showDeviceToken: false,
  api: {
    url: 'https://apis.dev.auckland.ac.nz/mfa/v1/',
  },
  auth: {
    codeChallengeMethod: 'S256',
    cognitoAwsRegion: 'ap-southeast-2',
    cognitoClientId: '680qsiekhkccv5h8jmokfe7juo',
    cognitoDomain: 'mytokenpool-dev',
    cognitoUserPoolId: 'ap-southeast-2_exoH1oHul',
    scopes: 'openid profile',
    redirectUri: 'https://mytoken.dev.auckland.ac.nz',
    logoutUri: 'https://mytoken.dev.auckland.ac.nz',
  },
  privateUrlKeyWords: {
    whoNeedBearerToken: [{url:'apis.dev.auckland.ac.nz/mfa/v1/',optional:false}],
  },
};
